function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { RangeState, useWeekView } from '../../../hooks/date';
import { classnames } from '@bydesign-ui/utils';
import React, { memo, useCallback } from 'react';
import { useLocale, usePrefixCls } from '@byte-design/config';
import { useDateState } from '../hooks/useDateState';
import { ViewCol } from '../units/ViewCol';
import { ViewGrid } from '../units/ViewGrid';
import { ViewGroup } from '../units/ViewGroup';
import { ViewNav } from '../units/ViewNav';
import { ViewRow } from '../units/ViewRow';
import { DateViewTitle } from './DateView';
export function WeekViewWeekItem(props) {
  var item = props.item,
      prefix = props.prefix,
      onSelect = props.onSelect,
      onHover = props.onHover;
  var week = item.week,
      disabledState = item.disabledState;
  var disabled = disabledState !== RangeState.NONE;
  var onClick = useCallback(function () {
    if (disabled) {
      return;
    }

    onSelect(item);
  }, [item, disabled, onSelect]);
  var onMouseEnter = useCallback(function () {
    if (disabled) {
      return;
    }

    onHover && onHover(item);
  }, [item, disabled, onHover]);
  var cls = classnames(usePrefixCls(prefix, {
    'week-list': true,
    item: true
  }, true), useDateState(prefix, item));
  return React.createElement("div", {
    className: cls,
    onClick: onClick,
    onMouseEnter: onMouseEnter
  }, week);
}
export function WeekViewDateItem(props) {
  var item = props.item,
      prefix = props.prefix;
  var date = item.date;
  var cls = classnames(usePrefixCls(prefix, {
    week: true,
    item: true
  }, true), useDateState(prefix, item));
  return React.createElement("div", {
    className: cls
  }, date);
}
export function WeekViewRow(props) {
  var item = props.item,
      prefix = props.prefix,
      onSelect = props.onSelect,
      onHover = props.onHover,
      enableInvalidTooltip = props.enableInvalidTooltip;
  var disabledState = item.disabledState;
  var isItemDisabled = disabledState !== RangeState.NONE;
  var onClick = useCallback(function () {
    if (isItemDisabled) {
      return;
    }

    onSelect(item);
  }, [item, isItemDisabled, onSelect]);
  var onMouseEnter = useCallback(function () {
    if (isItemDisabled) {
      return;
    }

    onHover && onHover(item);
  }, [item, isItemDisabled, onHover]);
  return React.createElement(ViewRow, {
    prefix: prefix,
    type: "week",
    state: item,
    onClick: onClick,
    onMouseEnter: onMouseEnter
  }, item.dateList.map(function (col) {
    return React.createElement(ViewCol, {
      enableInvalidTooltip: enableInvalidTooltip,
      prefix: prefix,
      type: "week",
      key: col.key,
      state: col
    }, React.createElement(WeekViewDateItem, {
      prefix: prefix,
      item: col
    }));
  }));
}
export var WeekView = memo(function (props) {
  var locale = useLocale('date.week');
  var date = useLocale('date');

  var part = props.part,
      prefix = props.prefix,
      position = props.position,
      owner = props.owner,
      hideNextYear = props.hideNextYear,
      hidePrevYear = props.hidePrevYear,
      hidePrevMonth = props.hidePrevMonth,
      hideNextMonth = props.hideNextMonth,
      className = props.className,
      enableInvalidTooltip = props.enableInvalidTooltip,
      extra = _objectWithoutProperties(props, ["part", "prefix", "position", "owner", "hideNextYear", "hidePrevYear", "hidePrevMonth", "hideNextMonth", "className", "enableInvalidTooltip"]);

  var _useWeekView = useWeekView(part),
      year = _useWeekView.year,
      month = _useWeekView.month,
      setCurrentWeekVirtual = _useWeekView.setCurrentWeekVirtual,
      setCurrentWeek = _useWeekView.setCurrentWeek,
      weekList = _useWeekView.weekList,
      dayList = _useWeekView.dayList,
      prevYear = _useWeekView.prevYear,
      nextYear = _useWeekView.nextYear,
      prevMonth = _useWeekView.prevMonth,
      nextMonth = _useWeekView.nextMonth,
      changeToYear = _useWeekView.changeToYear,
      changeToMonth = _useWeekView.changeToMonth;

  var cls = classnames(usePrefixCls(prefix, {
    view: true,
    week: true,
    owner: owner,
    position: position
  }, true), className);
  return React.createElement("div", Object.assign({}, extra, {
    className: cls
  }), React.createElement(ViewNav, {
    isDoublePrevHidden: hidePrevYear,
    isDoubleNextHidden: hideNextYear,
    isNextHidden: hideNextMonth,
    isPrevHidden: hidePrevMonth,
    prev: prevMonth,
    next: nextMonth,
    doublePrev: prevYear,
    doubleNext: nextYear,
    type: "week",
    prefix: prefix
  }, React.createElement(DateViewTitle, {
    prefix: prefix,
    year: year,
    month: month,
    changeToYear: changeToYear,
    changeToMonth: changeToMonth
  })), React.createElement(ViewGroup, {
    prefix: prefix,
    type: "week"
  }, React.createElement(ViewGrid, {
    prefix: prefix,
    type: "week-list",
    position: position === RangeState.START || position === RangeState.IN ? RangeState.START : RangeState.SINGLE
  }, React.createElement(ViewRow, {
    prefix: prefix,
    type: "week-list",
    key: "header"
  }, React.createElement(ViewCol, {
    enableInvalidTooltip: enableInvalidTooltip,
    prefix: prefix,
    type: "week-list"
  }, locale)), weekList.map(function (row) {
    return React.createElement(ViewRow, {
      prefix: prefix,
      key: row.week,
      type: "week-list"
    }, React.createElement(ViewCol, {
      enableInvalidTooltip: enableInvalidTooltip,
      prefix: prefix,
      type: "week-list",
      state: row
    }, React.createElement(WeekViewWeekItem, {
      prefix: prefix,
      item: row,
      onSelect: setCurrentWeek,
      onHover: setCurrentWeekVirtual
    })));
  })), React.createElement(ViewGrid, {
    prefix: prefix,
    type: "week",
    position: position === RangeState.END || position === RangeState.IN ? RangeState.END : RangeState.SINGLE
  }, React.createElement(ViewRow, {
    prefix: prefix,
    type: "date-header",
    key: "header"
  }, dayList.map(function (item) {
    return React.createElement(ViewCol, {
      enableInvalidTooltip: enableInvalidTooltip,
      prefix: prefix,
      type: "date",
      key: item
    }, date.shortestDayList[item]);
  })), weekList.map(function (row) {
    return React.createElement(WeekViewRow, {
      enableInvalidTooltip: enableInvalidTooltip,
      key: row.key,
      item: row,
      prefix: prefix,
      onSelect: setCurrentWeek,
      onHover: setCurrentWeekVirtual
    });
  }))));
});